import { httpWithAuth } from '~/clients';
import { SAVED_SEARCH, GET_SAVED_SEARCH } from '~/constants/endpoints';
import type { SavedSearch } from '~/contracts/common';
import BrowserCookies from '~/utilities/BrowserCookies';

export type LegacySavedSearch = {
  name: string;
  savedSearchId: number;
  url: string;
};

type SavedSearchResponse = {
  email: string;
  savedSearches?: LegacySavedSearch[];
};

export function createSavedSearch(
  payload: {
    email: string;
    name: string;
    url: string;
    userId: string;
    zip5: string;
  },
  controller?: AbortController
) {
  return httpWithAuth.post<SavedSearchResponse>(
    SAVED_SEARCH,
    {
      ...payload,
      isEmailCampaignActive: true,
      isSmsCampaignActive: false,
      browserCookieId: BrowserCookies.get('BrowserCookieId')
    },
    {
      signal: controller?.signal
    }
  );
}

export function readSavedSearch(query: string, controller?: AbortController) {
  return httpWithAuth.get<SavedSearch[]>(`${GET_SAVED_SEARCH}?${query}`, {
    signal: controller?.signal
  });
}

export function deleteSavedSearch(
  savedSearchId: number,
  controller?: AbortController
) {
  return httpWithAuth.delete<SavedSearchResponse>(SAVED_SEARCH, {
    data: { savedSearchId },
    signal: controller?.signal
  });
}
